import { z } from 'zod'
import {
	LINK_KINDS,
	LINK_VIEWS
} from '@/routes/(private)/(shell)/-lib/link-views'

/**
 * URL-owned filters for `/links` — `GET /links` offers `state` alone, and
 * nothing else: unlike `/admin/links` there is no `creatorId` (the listing
 * is already the caller's own), no `expiresWithinDays`, no `hasPassword`.
 * `search` matches the linked resource's name, server-side, in any view —
 * `ListInputSearch` owns it.
 */
export const linksSearchSchema = z.object({
	kind: z.enum(LINK_KINDS).default('all'),
	view: z.enum(LINK_VIEWS).default('live'),
	search: z.string().trim().default('')
})
